import * as React from 'react';

import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { useGetParking } from 'src/features/parkingManagement/api/useGetParking.ts';
import { useParkingAPIConfigs } from 'src/features/parkingManagement/api/useParkingAPIConfigs.ts';
import IntegrationsForm from 'src/features/parkingManagement/components/forms/IntegrationsForm.tsx';
import { useTitleStore } from 'src/stores/useTitleStore.ts';

const Integrations = () => {
    const { formatMessage } = useIntl();
    const { parkingId } = useParams();
    const { data } = useGetParking({
        parkingId: parkingId || '',
        config: {
            enabled: !!parkingId,
        },
    });
    const { data: parkingAPIConfig, refetch } = useParkingAPIConfigs({
        parkingId: parkingId || '',
        config: {
            enabled: !!parkingId,
        },
    });
    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        if (!data) return;
        setTitle(data.name);
        return () => {
            removeTitle();
        };
    }, [data, formatMessage]);

    return <IntegrationsForm data={parkingAPIConfig?.results[0]} refetch={refetch} />;
};

export default Integrations;
